import React, { useEffect, useState } from "react";
import "./DematSelectionForm.scss";
import Radio from "../UI/Radio/Radio";
import { SubmitButton } from "../UI/Button/Button";
import InputField from "../UI/InputField/InputField";
import foldUploadIcon from "../../assets/icons/foldUploadIcon.jpg";
import edit from "../../assets/icons/edit.jpg";
import Loader from "../UI/Loader/Loader";
import { alphaNumExp } from "../utils/regex";
import GlobalStore from "../store/globalStore";
import {
  ADPverification,
  AGetDPDetails,
  AGetDPName,
  ASaveDematDetails,
  AUploadDocument,
} from "../Services/dashboard/brokerageServices";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  completeModuleStatus,
  incompleteStageNavigation,
} from "../Services/globalService";
import ErrMsg from "../UI/ErrMsg/ErrMsg";
import { dashboardUrl } from "../utils/constants";
import {
  ADownloadDocument,
  AGetDocStatus,
  AGetUploadedDocument,
} from "../Services/dashboard/docVerificationAPIServices";
import { DocDetailFormat } from "../UI/DocumentBrowse/DocumentBrowse";
import { decryptJwtToken } from "../Services/dashboard/encryptionNew";
import { ITokenObj } from "../types/genericTypes";
import { errorCode, errorMsg } from "../../ErrorCode/ErrorCode";
import { SUBTYPE_DOCUMENT_ID } from "../Registration/PANInfo/PANInfoJoint.utils";
export interface IDematSelection {
  dpId: string;
  clientId: string;
  radioSelection?: boolean;
  fileName?: string;
  base64String?: string;
  dpName?: string;
}
const DematSelectionForm = (props: any) => {
  // const history = useHistory();
  const navigate = useNavigate();
  const [radioSelection, setRadioSelection] = React.useState<boolean>(true);
  const [formData, setFormData] = React.useState<IDematSelection>({
    dpId: "",
    clientId: "",
    radioSelection: true,
    dpName: "",
  });
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [uploadedMaxFile, setUploadedMaxFile] = React.useState<boolean>(false);
  const [fileLoader, setFileLoader] = React.useState<boolean>(false);
  const [dpLoader, setDpLoader] = React.useState<boolean>(true);
  const [dpIdType, setDpIdType] = React.useState<string>("");
  const [showAutoIfVerifyFail, setShowAutoVerifyFail] =
    React.useState<boolean>(false);
  const [foundVerificationFail, setFoundVerficationFail] =
    React.useState<boolean>(false);
  const [cdslFlowFind, setCdslFlowFind] = React.useState<boolean>(false);
  const [dpIsVerified, setDpIsVerified] = React.useState<boolean>(false);
  const [showUploadSection, setShowUploadSection] =
    React.useState<boolean>(false);

  const onChanges = (key: string, value: any) => {
    setFormData((form) => {
      return {
        ...form,
        [key]: value,
      };
    });
  };

  function getbase64(dataString: string, mimeType?: string) {
    return (
      "data:" +
      (mimeType === "application/pdf" ? "application/pdf" : "image/jpeg") +
      ";base64," +
      dataString
    );
  }
  const [regectedDocStatus, setRegectedDocStatus] = React.useState<
    Array<object>
  >([{}]);
  const getRejectedReason = () => {
    AGetDocStatus(getDocumentStatus, GlobalStore.applicationID);
  };
  const getDocumentStatus = (res: any) => {
    if (!res || res.error) {
      // setErrCode("164- Failed to get the document status for the application.");
      setErrCode(errCode + res.error);
      //  gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR125" });
    } else {
      if (res.data) {
        const regectedDoc = JSON.parse(res.data).filter(
          (item: any) => item.Status === "Rejected",
        );
        if (regectedDoc !== undefined && regectedDoc?.length > 0) {
          setFormData((formData) => {
            formData.fileName = "";
            formData.base64String = "";
            return formData;
          });
        }
        setRegectedDocStatus(regectedDoc);
      } else {
        // gtmService({
        //   action: "GetDocumentDetails",
        //   label: "ERROR || ERR125-S",
        // });
      }
    }
  };
  const getUploadeDocument = () => {
    AGetUploadedDocument((res: any) => {
      if (!res || res.error) {
        // setErrCode(164)
        setErrCode(errCode + res.error);
        // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
      } else if (res.data) {
        const uplDoc = JSON.parse(res.data);
        const dematAccount = uplDoc.filter(
          (x: any) => x.DocumentCategoryId === 96,
        );

        if (dematAccount?.length > 0) {
          const file = dematAccount[0];

          setFormData((prev: any) => ({
            ...prev,
            fileName: file.FileName,
          }));

          ADownloadDocument(
            (res: any) => {
              if (!res || res.error) {
                setErrCode(errCode + res.error);
                // gtmService({
                //   action: "DownloadDocumentFromS3",
                //   label: "ERROR || ERR126",
                // });
              } else if (res.data) {
                const base64 = getbase64(
                  res.data.base64document,
                  file.MimeType,
                );

                setFormData((prev: any) => ({
                  ...prev,
                  base64String: base64,
                }));
              }
            },
            file.FileName,
            file.UploadedDocPath,
          );
        }
      }
    }, GlobalStore.applicationID);
    // setFormDPData();
  };
  const getDPDetails = () => {
    setDpLoader(true);
    AGetDPDetails((res: any) => {
      if (!res || res.error) {
        // setErrCode(164)
        setErrCode(errCode + res.error);
        setDpLoader(false);
        // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
      } else if (res.data && res.data !== null) {
        let newResp = JSON.parse(res.data);
        if (newResp?.dpid !== "" && newResp?.clientId !== "") {
          setFormData((formData) => {
            formData.dpId = newResp.dpid;
            formData.clientId = newResp.clientid;
            formData.dpName = newResp.dpname;
            determineDepository(formData.dpId, formData?.clientId, true, true);
            formData.radioSelection = newResp.dpavailable;
            setRadioSelection(
              newResp?.dpavailable !== null ? newResp.dpavailable : false,
            );
            //  getUploadeDocument();
            return formData;
          });
          setDpLoader(false);
        } else {
          setFormData({
            dpId: "",
            clientId: "",
            dpName: "",
            radioSelection:
              newResp?.dpavailable !== null && newResp?.isdpcompleted
                ? newResp.dpavailable
                : true,
          });
          setRadioSelection(
            newResp?.isdpcompleted && newResp?.dpavailable !== null
              ? newResp.dpavailable
              : true,
          );
          setDpLoader(false);
        }
      } else if (res.data === null) {
        setDpLoader(false);
        setFormData({
          dpId: "",
          clientId: "",
          dpName: "",
          radioSelection: true,
        });
      }
    }, GlobalStore?.applicationID);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    setFoundVerficationFail(false);
    getRejectedReason();
    getDPDetails();
    getUploadeDocument();
  }, []);
  function getMimeType(base64String?: string) {
    // Split the string to get the metadata part before the comma
    if (base64String !== null && base64String !== undefined) {
      const mimeType = base64String.match(/^data:([^;]+);base64,/);

      // Return MIME type if present, otherwise return null
      return mimeType ? mimeType[1] : ".";
    }
    return ".";
  }

  const SaveDematDetails = (dpVerify?: boolean) => {
    let userId = "0";
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = tokenMainObj?.UserId?.toString();
    }
    const saveDpObj = {
      applicationId: GlobalStore?.applicationID,
      dpAvailable: formData?.radioSelection,
      dPid: formData?.dpId,
      dpName: formData?.dpName,
      clientid: formData?.clientId,
      createdBy: parseInt(userId),
      IsDPVerified:
        dpIdType == "CDSL"
          ? false
          : dpVerify !== null && dpVerify !== undefined
            ? dpVerify
            : dpIsVerified,
      leadId: GlobalStore?.leadId,
    };
    ASaveDematDetails((res: any) => {
      if (!res || res.error) {
        setIsLoading(false);
        // gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
        // setIsLoading(false);
        // handErrorForFileUpload(id, res);
        setErrCode(res.error);
      } else {
        if (res.data) {
          completeModuleStatus(dashboardUrl.demat);
          // history.push(incompleteStageNavigation(dashboardUrl.demat));
          navigate(incompleteStageNavigation(dashboardUrl.demat));
          setIsLoading(false);
        }
      }
    }, saveDpObj);
  };
  const handleSubmit = (cdslFinalSubmit?: boolean) => {
    if (
      formData?.radioSelection !== null &&
      formData?.radioSelection !== undefined &&
      formData?.radioSelection == false
    ) {
      setTimeout(() => {
        setIsLoading(true);
        SaveDematDetails();
      }, 2000);
    } else {
      if (dpIdType === "NSDL" && !foundVerificationFail) {
        setIsLoading(true);
        Dpverify();
      }
      if (dpIdType === "NSDL" && foundVerificationFail) {
        setIsLoading(true);
        uploadDocumentFile(formData?.fileName, formData?.base64String);
        // SaveDematDetails();
      }
      if (dpIdType === "CDSL") {
        setIsLoading(true);
        uploadDocumentFile(formData?.fileName, formData?.base64String);
        // SaveDematDetails();
        // if (cdslFlowFind) {
        //   setShowUploadSection(true);
        // }
        // if (cdslFinalSubmit !== undefined && cdslFinalSubmit) {

        // }
      }
      if (dpIdType == '' && !showUploadSection) {
        setIsLoading(true);
        SaveDematDetails();
      } 
    }
  };
  const onRemoveDocUpload = () => {
    setFileLoader(true);
    setTimeout(() => {
      setFormData((formData) => {
        formData.fileName = "";
        formData.base64String = "";
        setFileLoader(false);
        return formData;
      });
    }, 200);
  };
  const Dpverify = (dpVerify?: boolean, stopSaveApi?: boolean, clientId?: any) => {
    let dpVerifyAutoObj = {
      applicationId: GlobalStore?.applicationID,
      dpId: formData?.dpId,
      clientId: clientId || formData?.clientId,
      panNo: GlobalStore?.personaldetails?.pan,
    };
    ADPverification((res: any) => {
      if (!res || res.error) {
        // gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
        // setIsLoading(false);
        // handErrorForFileUpload(id, res);
        setErrCode(res.error);
      } else {
        if (res && res.data !== null) {
          if (res?.data !== null && res?.data) {
            if (
              stopSaveApi !== null &&
              stopSaveApi !== undefined &&
              stopSaveApi
            ) {
              setDpIsVerified(true);
            } else {
              SaveDematDetails(true);
            }
          } else {
            setIsLoading(false);
            if (dpVerify !== null && dpVerify !== undefined && dpVerify) {
            } else {
              setFormData((formData) => {
                formData.fileName = "";
                formData.base64String = "";
                return formData;
              });
            }

            if (dpVerify !== null && dpVerify !== undefined && dpVerify) {
            } else {
              setDpIsVerified(false);
              setShowAutoVerifyFail(true);
            }
            setFoundVerficationFail(true);
            setShowUploadSection(true);
          }
        }
      }
    }, dpVerifyAutoObj);
  };
  const onEditIcon = () => {
    setShowUploadSection(false);
    // setCdslFlowFind(false);
    setFormData((formData) => {
      formData.base64String = "";
      formData.fileName = "";
      return formData;
    });
  };
  const uploadDocumentFile = (fileName?: string, val?: string) => {
    let saveDetails = [];
    let saveUploadObj = {
      documentCategoryId: "96",
      documentId: SUBTYPE_DOCUMENT_ID[GlobalStore.entitySubType] || "626",
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: true,
      personaldetailsid: "0",
      autoqc: false,
      iskycdocument: false,
    };
    saveDetails.push(saveUploadObj);
    const modifiedBy = window.sessionStorage.getItem("empCode");
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails?.pan,
      ModifiedBy: modifiedBy && modifiedBy != "" ? modifiedBy : 0,
    };
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      ModifiedBy: modifiedBy && modifiedBy != "" ? modifiedBy : 0,
      // objUTM_Info: objUTM_Info,
    };
    setFormData((form) => {
      formData.fileName = fileName;
      formData.base64String = val;
      return form;
    });
    AUploadDocument(
      (res: any) => {
        if (!res || res.error) {
          // gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
          // setIsLoading(false);
          // handErrorForFileUpload(id, res);
          setErrCode(res.error);
          setIsLoading(false);
        } else {
          if (res.data !== null && res?.data) {
            SaveDematDetails();
          }
        }
      },
      uploadObj,
      (event: ProgressEvent) => {},
      saveObj,
    );
  };
  // console.log("FormDAta", formData);
  const onFileUpload = (
    fileUploadEvent: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setUploadedMaxFile(false);
    setFileLoader(true);
    setErrCode("");
    setRegectedDocStatus([]);
    const elem = fileUploadEvent.target;
    const file = elem.files && elem.files[0];
    if (file !== null && file !== undefined) {
      if (file && file.name.split(".").length === 2) {
        let extensions = file.name.split(".");
        if (file.size > 3145728) {
          setUploadedMaxFile(true);
        } else {
          setUploadedMaxFile(false);
          if (
            extensions[extensions.length - 1].toUpperCase() === "PDF" ||
            extensions[extensions.length - 1].toUpperCase() === "pdf"
          ) {
            if (elem.files && elem.files[0]) {
              const reader = new FileReader();
              reader.onload = function (e) {
                const images = (e.target && e.target.result)?.toString();
                if (dpIdType === "NSDL") {
                  setShowAutoVerifyFail(false);
                }
                // onChanges("fileName", file?.name);
                // onChanges("base64String", images);
                setFormData((form) => {
                  formData.fileName = file?.name;
                  formData.base64String = images;
                  return form;
                });
                //   uploadDocumentFile(file?.name, images);
                setFileLoader(false);
              };
              reader.readAsDataURL(elem.files[0]);
            }
          }
          // else alert('Please upload a pdf file.')
          else setErrCode("Please upload a pdf file.");
        }
      }
    }
  };
  const validateDPID = (dpId: string) => {
    const dpIdPattern = /^[A-Za-z0-9]{8}$/; // DP ID: exactly 8 alphanumeric characters

    if (dpIdPattern.test(dpId)) {
      return false;
    } else {
      return true;
    }
  };
  const validateClientID = (clientId: string) => {
    const dpIdNumericPattern = /^\d{8}$/;
    if (dpIdNumericPattern.test(clientId)) {
      return false;
    } else return true;
  };
  function determineDepository(
    dpId?: any,
    dematAccount?: any,
    byGet?: boolean,
    fromApi?: boolean,
  ) {
    setCdslFlowFind(false);
    const dpIdAlphanumericPattern = /^[A-Za-z0-9]{8}$/; // DP ID: 8 alphanumeric characters
    const dpIdNumericPattern = /^\d{8}$/; // DP ID: exactly 8 digits
    const dematPattern = /^\d{8}$/; // Demat Account: exactly 8 digits
    let dpType: string = "";
    if (dpIdNumericPattern.test(dpId) && dematPattern.test(dematAccount)) {
      dpType = "CDSL"; // Both DP ID and Demat Account are 8 digits
      setCdslFlowFind(true);
    } else if (
      dpIdAlphanumericPattern.test(dpId) &&
      dematPattern.test(dematAccount)
    ) {
      dpType = "NSDL"; // DP ID is alphanumeric but not all digits
    }
    setDpIdType((dpIdType) => {
      dpIdType = dpType;
      return dpIdType;
    });
    if (GlobalStore.isOTCFlow) {
      if (dpIdNumericPattern.test(dematAccount)) {
        Dpverify(true, true, dematAccount);
      }
    } else {
      if (byGet !== null && byGet !== undefined && byGet) {
        if (dpType == "NSDL") {
          Dpverify(true, true);
        }
      }
      if (dpType !== "" && dpType === "CDSL" && dpType == "CDSL") {
        setShowUploadSection(true);
      } else {
        setShowUploadSection(false);
      }
    }
    // if (fromApi !== undefined && fromApi !== null && fromApi) {

    // }
  }
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [errors, setErrors] = React.useState<IDematSelection>({
    dpId: "",
    clientId: "",
  });
  const setCdslFinalSubmit = () => {
    if (
      dpIdType === "CDSL" &&
      cdslFlowFind &&
      !!formData?.fileName &&
      formData?.fileName !== "" &&
      !!formData?.base64String &&
      formData?.base64String !== ""
    ) {
      return true;
    }
    // let proceedFurther = false;
    // setFormData((formData) => {

    //   return formData;
    // });

    // return proceedFurther;
  };
  const disabledButton = () => {
    let disabledButtonCo: boolean = false;
    console.log("formdataaa", formData);

    if (
      formData?.radioSelection == null &&
      formData?.radioSelection === undefined
    ) {
      disabledButtonCo = true;
    } else {
      if (
        !!formData?.dpId &&
        formData?.dpId !== "" &&
        !!formData?.dpId &&
        formData?.dpId !== "" &&
        !!formData?.clientId &&
        formData?.clientId !== ""
      ) {
        if (dpIdType === "NSDL") {
          if (showAutoIfVerifyFail) {
            disabledButtonCo = true;
          } else {
            if (
              foundVerificationFail &&
              !!formData?.fileName &&
              formData?.fileName !== "" &&
              !!formData?.base64String &&
              formData?.base64String !== ""
            ) {
              disabledButtonCo = false;
            } else if (foundVerificationFail === false)
              disabledButtonCo = false;
            else disabledButtonCo = true;
          }
        } else if (dpIdType === "CDSL") {
          if (
            !!formData?.fileName &&
            formData?.fileName !== "" &&
            !!formData?.base64String &&
            formData?.base64String !== ""
          ) {
            disabledButtonCo = false;
          } else {
            if (showUploadSection == false) {
              disabledButtonCo = false;
            } else disabledButtonCo = true;
          }
        }
      } else {
        if (formData?.radioSelection === false) {
          disabledButtonCo = false;
        } else disabledButtonCo = true;
      }
    }

    return disabledButtonCo;
  };

  const fetchDpName = (dpId: string) => {
    AGetDPName((res: any) => {
      try {
        if (res?.data?.dbelist) {
          setFormData((prev) => ({
            ...prev,
            dpName: res.data.dbelist[0]?.dpname,
          }));
        }
      } catch (error) {
        console.log("DP Name API Error", error);
      }
    }, dpId);
  };

  return (
    <>
      {dpLoader && (
        <div className="demat_loader">
          <Loader size={50} />
        </div>
      )}
      {!dpLoader && (
        <div className="dematFormMain">
          {!GlobalStore.isOTCFlow && (
            <>
              <div className="dematHeadingForm">Link your Demat Account</div>
              {GlobalStore.entitySubType == "Joint" ? (
                <div className="dematSubHeadingForm">
                  Unlock a world of investment opportunities by linking your
                  demat account to your new investment account. Dive into
                  commodities (SGB), fixed income, and more! However, upgrade to
                  a trading account to access the exciting realm of secondary
                  market trading .
                </div>
              ) : (
                <div className="dematSubHeadingForm">
                  You can link your existing{" "}
                  <b>Nuvama Demat Account (if available)</b> or a External Demat
                  account to experience the Investment Product offered under the
                  Wealth Starters Account. Alternatively, if you wish to invest
                  solely in <b>Mutual Funds</b> and Non-Demat products, you have
                  the option to proceed without linking any Demat account
                </div>
              )}
              <div className="dematFormRadioSelection mgt20">
                <Radio
                  checked={radioSelection == true}
                  className=""
                  onChange={() => {
                    setRadioSelection(true);
                    onChanges("radioSelection", true);
                  }}
                  name="radioSelection"
                  label="Yes"
                  //disabled={true}
                />
                <Radio
                  className="mgl10"
                  checked={radioSelection == false}
                  onChange={() => {
                    onChanges("radioSelection", false);
                    setRadioSelection(false);
                    setFoundVerficationFail(false);
                    setShowUploadSection(false);
                    onChanges("clientId", "");
                    onChanges("dpId", "");
                    setDpIdType("");
                    setShowAutoVerifyFail(false);
                  }}
                  name="radioSelection"
                  label="No"
                  //disabled={true}
                />
              </div>
            </>
          )}
          {radioSelection && (
            <>
              <div>
                <div className="dp-id-row">
                  <label className="inptLbl">Enter DP ID</label>
                  <InputField
                    className=""
                    disabled={dpIsVerified}
                    defaultValue={formData?.dpId} //To be removed
                    onChange={(value) => {
                      setShowUploadSection(false);
                      onChanges("dpId", value);
                      setFormData((prev) => ({
                        ...prev,
                        fileName: "",
                        base64String: "",
                      }));
                      if (!value) {
                        setErrors({
                          ...errors,
                          dpId: "",
                        });
                        return;
                      }
                      if (value.length === 8 && /^0+$/.test(value)) {
                        setErrors({
                          ...errors,
                          dpId: "DP ID cannot be all zeros",
                        });
                        return;
                      }
                      if (value.length === 8) {
                        fetchDpName(value);
                      }
                      if (value.length > 0 && !validateDPID(value)) {
                        setFoundVerficationFail(false);
                        setShowAutoVerifyFail(false);
                        onChanges("clientId", "");
                      }
                      setErrors({
                        ...errors,
                        dpId: "",
                      });
                    }}
                    required={true}
                    pattern={alphaNumExp}
                    onBlur={(error: any, event) => {
                      const value = event?.target?.value;
                      const regex = /\d/; // At least one digit

                      // Required validation
                      if (error.required) {
                        setErrors({
                          ...errors,
                          dpId: errorMsg(errorCode.FE57),
                        });
                        return;
                      }

                      // If user entered only spaces
                      if (
                        value &&
                        value.length > 0 &&
                        !value.replace(/\s/g, "").length
                      ) {
                        setErrors({
                          ...errors,
                          dpId: errorMsg(errorCode.FE55),
                        });
                        return;
                      }

                      // ❗ Check 8-digit all-zero case
                      if (value && value.length === 8 && /^0+$/.test(value)) {
                        setErrors({
                          ...errors,
                          dpId: "DP ID cannot be all zeros",
                        });
                        return;
                      }

                      // No digit present
                      if (value && value.length > 0 && !regex.test(value)) {
                        setErrors({
                          ...errors,
                          dpId: errorMsg(errorCode.FE56),
                        });
                        return;
                      }

                      // Invalid according to validate function
                      if (value && value.length > 0 && validateDPID(value)) {
                        setErrors({
                          ...errors,
                          dpId: errorMsg(errorCode.FE56),
                        });
                        return;
                      }

                      // If everything is fine
                      setErrors({
                        ...errors,
                        dpId: "",
                      });
                    }}
                    type="text"
                    placeholder="Eg. 18273946"
                    //  pattern={pan}
                    errorText={errors?.dpId}
                    maxLength={8}
                    // suffix={
                    //   <>
                    //     {cdslFlowFind && (
                    //       <span
                    //         onClick={(e) => {
                    //           onEditIcon();
                    //         }}
                    //       >
                    //         <img src={edit} height={40} width={60}></img>
                    //       </span>
                    //     )}
                    //   </>
                    // }
                  />
                </div>
                <div className="client-id-row">
                  <label className="inptLbl">Enter Client ID</label>
                  <InputField
                    className=""
                    disabled={dpIsVerified}
                    defaultValue={formData?.clientId} //To be removed
                    onChange={(value) => {
                      setShowUploadSection(false);
                      onChanges("clientId", value);
                      if (!value) {
                        setErrors({
                          ...errors,
                          clientId: "",
                        });
                        return;
                      }
                      if (value.length === 8 && /^0+$/.test(value)) {
                        setErrors({
                          ...errors,
                          clientId: "Client ID cannot be all zeros",
                        });
                        return;
                      }
                      setErrors({
                        ...errors,
                        clientId: "",
                      });
                      if (value.length > 0) {
                        determineDepository(formData?.clientId, value);
                      }
                    }}
                    required={true}
                    pattern={alphaNumExp}
                    onBlur={(error: any, event) => {
                      const value = event?.target?.value;

                      // Required validation
                      if (error.required) {
                        setErrors({
                          ...errors,
                          clientId: errorMsg(errorCode.FE57),
                        });
                        return;
                      }

                      // If only spaces
                      if (
                        value &&
                        value.length > 0 &&
                        !value.replace(/\s/g, "").length
                      ) {
                        setErrors({
                          ...errors,
                          clientId: errorMsg(errorCode.FE55),
                        });
                        return;
                      }

                      // ❗ Check 8-digit all-zero case
                      if (value && value.length === 8 && /^0+$/.test(value)) {
                        setErrors({
                          ...errors,
                          clientId: "Client ID cannot be all zeros",
                        });
                        return;
                      }

                      // validateClientID failed
                      if (
                        value &&
                        value.length > 0 &&
                        validateClientID(value)
                      ) {
                        setErrors({
                          ...errors,
                          clientId: errorMsg(errorCode.FE54),
                        });
                        return;
                      }

                      // Valid case - clear error
                      setErrors({
                        ...errors,
                        clientId: "",
                      });
                    }}
                    type="text"
                    placeholder="Eg. 18273946"
                    //  pattern={pan}
                    errorText={errors?.clientId}
                    maxLength={8}
                    onKeyPress={(
                      keyEvent: React.KeyboardEvent<HTMLInputElement>,
                    ) => {
                      if (keyEvent.key >= "0" && keyEvent.key <= "9") {
                        return true;
                      } else {
                        if (
                          keyEvent.key !== "Backspace" &&
                          keyEvent.key !== "Enter"
                        )
                          keyEvent.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className="client-id-row">
                  <label className="inptLbl">DP Name</label>
                  <InputField
                    className=""
                    disabled={dpIsVerified}
                    defaultValue={formData?.dpName} //To be removed
                    onChange={(value) => {
                      setShowUploadSection(false);
                      onChanges("dpName ", value);
                      if (!value) {
                        setErrors({
                          ...errors,
                          dpName: "",
                        });
                        return;
                      }
                      if (value.length === 8 && /^0+$/.test(value)) {
                        setErrors({
                          ...errors,
                          dpName: "DP Name cannot be empty",
                        });
                        return;
                      }
                      setErrors({
                        ...errors,
                        dpName: "",
                      });
                    }}
                    required={true}
                    pattern={alphaNumExp}
                    onBlur={(error: any, event) => {
                      const value = event?.target?.value;

                      // Required validation
                      if (error.required) {
                        setErrors({
                          ...errors,
                          dpName: errorMsg(errorCode.FE57),
                        });
                        return;
                      }

                      // If only spaces
                      if (
                        value &&
                        value.length > 0 &&
                        !value.replace(/\s/g, "").length
                      ) {
                        setErrors({
                          ...errors,
                          dpName: errorMsg(errorCode.FE55),
                        });
                        return;
                      }

                      // ❗ Check 8-digit all-zero case
                      if (value && value.length === 8 && /^0+$/.test(value)) {
                        setErrors({
                          ...errors,
                          dpName: "Client ID cannot be all zeros",
                        });
                        return;
                      }

                      // validateClientID failed
                      // if (value && value.length > 0) {
                      //   setErrors({
                      //     ...errors,
                      //     dpName: errorMsg(errorCode.FE54),
                      //   });
                      //   return;
                      // }

                      // Valid case - clear error
                      setErrors({
                        ...errors,
                        dpName: "",
                      });
                    }}
                    type="text"
                    placeholder="Eg. Broker Name"
                    //  pattern={pan}
                    errorText={errors?.dpName}
                    // maxLength={8}
                    onKeyPress={(keyEvent: React.KeyboardEvent<HTMLInputElement>) => {
                      const key = keyEvent.key;
                      if (/^[a-zA-Z]$/.test(key)) return;
                      const allowedKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete"
                      ];
                      if (!allowedKeys.includes(key)) {
                        keyEvent.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
              {showUploadSection && (
                <div className="upload-document-section">
                  {showAutoIfVerifyFail && (
                    <div className="auto-verify-error-section">
                      {errorMsg(errorCode.FE53)}
                    </div>
                  )}

                  <div className="upload-document-title">
                    Upload document to verification
                  </div>
                  <div className="upload-document-sub-title">
                    For us to verify your demat account kindly share your CML
                    Copy or Demat Statement (maximum 1 month old)
                  </div>
                  <div className="upload-document-sub-title">
                    Document should be in the same sequence as per the Account
                    Creation Sequence at Nuvama.
                  </div>
                  <div className="upload-file-section">
                    <label className="label-class">
                      <input
                        type="file"
                        disabled={false}
                        id={"cml upload"}
                        className="fileInput"
                        onChange={(e: any) => {
                          //     console.log("file uploading started");
                          onFileUpload(e);
                        }}
                        accept=".pdf"
                      />
                      Upload File
                      <span className="edel-icon-upload" />
                    </label>
                    <div>
                      {formData?.fileName !== undefined &&
                        formData?.fileName !== null &&
                        formData?.fileName !== "" &&
                        formData?.base64String !== undefined &&
                        formData?.base64String !== null &&
                        formData?.base64String !== "" && (
                          <span className="file-name-section">
                            <img src={foldUploadIcon} />
                            <span className="file-name">
                              {formData?.fileName}
                            </span>
                            {fileLoader ? (
                              <Loader size={18} />
                            ) : (
                              <div
                                onClick={() => {
                                  //   console.log("button is clicked");
                                  onRemoveDocUpload();
                                }}
                              >
                                <i className="edel-icon-close" />
                              </div>
                            )}
                          </span>
                        )}
                    </div>
                    {uploadedMaxFile && (
                      <div className="auto-verify-error-section">
                        please upload correct file(size is incorrect).
                      </div>
                    )}
                    {!formData?.fileName &&
                      regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20 mgt20">
                            {" "}
                            {item.ContentType === "PROOF OF DEMAT" && (
                              <ErrMsg>
                                <>
                                  <label>
                                    Reason for Rejection: {item.RejectionReason}
                                  </label>
                                </>
                              </ErrMsg>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
            </>
          )}
          {errCode && (
            <div className="errMsgBlck errWidth mrt40">
              <ErrMsg>
                {typeof errCode === "number" ? (
                  <>
                    <label>We are facing some technical issue.</label>
                    <label>
                      Please try after sometime (error code:{errCode})
                    </label>
                  </>
                ) : (
                  <label>{errCode}</label>
                )}
              </ErrMsg>
            </div>
          )}
          <div
            className={
              "save-button-container"
              // formData?.radioSelection == false
              //   ? "save-button-container-no"
              //   : dpIdType == "CDSL" ||
              //     (dpIdType == "NSDL" && showUploadSection)
              //     ? "cdsl-save-button-container"
              //     : "save-button-container"
            }
          >
            <SubmitButton
              isLoading={isLoading}
              btnName="Proceed"
              disabled={
                disabledButton() ||
                (typeof errCode === "string" && errCode != "")
              }
              onClick={() => {
                handleSubmit();
              }}
              type="submit"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DematSelectionForm;
